
import * as EmailValidator from "email-validator";

const isEmail = (value) => {
  // eslint-disable-next-line no-useless-escape
  if (value !== "" && EmailValidator.validate(value)) {
    return true;
  }
  return false;
};

export const validator = {
  isEmail
};